/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M17.5552 7.5C17.5552 5.01472 15.5654 3 13.1108 3H10.8885C8.43394 3 6.44409 5.01472 6.44409 7.5C6.44409 7.88846 6.49271 8.26543 6.58411 8.625"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M10.8886 12H13.1108C15.5654 12 17.5553 14.0147 17.5553 16.5C17.5553 18.9853 15.5654 21 13.1108 21H10.8886C8.43402 21 6.44417 18.9853 6.44417 16.5M3 12H21"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				d="M10.8886 12H13.1108C15.5654 12 17.5553 14.0147 17.5553 16.5C17.5553 18.9853 15.5654 21 13.1108 21H10.8886C8.43402 21 6.44417 18.9853 6.44417 16.5M17.5553 7.5C17.5553 5.01472 15.5654 3 13.1108 3H10.8886C8.43402 3 6.44417 5.01472 6.44417 7.5C6.44417 7.88846 6.49279 8.26543 6.58419 8.625M3 12H21"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				d="M10.8886 12H13.1108C15.5654 12 17.5553 14.0147 17.5553 16.5C17.5553 18.9853 15.5654 21 13.1108 21H10.8886C8.43402 21 6.44417 18.9853 6.44417 16.5M17.5553 7.5C17.5553 5.01472 15.5654 3 13.1108 3H10.8886C8.43402 3 6.44417 5.01472 6.44417 7.5C6.44417 7.88846 6.49279 8.26543 6.58419 8.625M3 12H21"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M13 12C15.4546 12 17.5553 14.0147 17.5553 16.5C17.5553 18.9853 15.5654 21 13.1108 21H10.8886C8.43402 21 6.44417 18.9853 6.44417 16.5M13 12H11M13 12H21M17.5553 7.5C17.5553 5.01472 15.5654 3 13.1108 3H10.8886C8.43402 3 6.44417 5.01472 6.44417 7.5C6.44417 7.88846 6.49279 8.26543 6.58419 8.625M3 12H7"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M10.8886 12H13.1108C15.5654 12 17.5553 14.0147 17.5553 16.5C17.5553 18.9853 15.5654 21 13.1108 21H10.8886C8.43402 21 6.44417 18.9853 6.44417 16.5M17.5553 7.5C17.5553 5.01472 15.5654 3 13.1108 3H10.8886C8.43402 3 6.44417 5.01472 6.44417 7.5C6.44417 7.88846 6.49279 8.26543 6.58419 8.625M3 12H21"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				d="M10.8886 12H13.1108C15.5654 12 17.5553 14.0147 17.5553 16.5C17.5553 18.9853 15.5654 21 13.1108 21H10.8886C8.43402 21 6.44417 18.9853 6.44417 16.5M17.5553 7.5C17.5553 5.01472 15.5654 3 13.1108 3H10.8886C8.43402 3 6.44417 5.01472 6.44417 7.5C6.44417 7.88846 6.49279 8.26543 6.58419 8.625M3 12H21"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
]);
